'use strict'

export default (mockAxios) => {
  mockAxios.onPost(`/favorited-bcards`).reply(201, {
    'success': true,
    'data': {
      'id': 1
    }
  })

  mockAxios.onDelete(new RegExp(`/favorited-bcards/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })

  mockAxios.onPut(new RegExp(`/favorited-bcards/bulk`)).reply(200, {
    'success': true,
    'data': []
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/favoriteRepositoryMock.js